import { orderFormSpace } from 'feature/productOrder/namespaces/orderFormSpace'
import { useUploadImageMutation } from 'feature/productOrder/redux/orders.api'
import { FC, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useActions } from 'store/hooks'
import { DragDropInput } from 'widget/DragDropFile/dragDropInput/DragDropInput'

interface IInputImages {
  files?: orderFormSpace.Images[]
  productId: number
  paramId?: number
  name: string
}

// параметр продукта с типом file
export const InputImages: FC<IInputImages> = ({
  files,
  productId,
  name,
  paramId,
}) => {
  const { control } = useForm()
  const { addAllImagesList, removeImagesInAllList } = useActions()
  const [fileList, setFileList] = useState<orderFormSpace.Images[]>([])

  const [uploadImage] = useUploadImageMutation()

  const loadFile = async (file: File) => {
    const ImgData = await uploadImage(file).unwrap()
    return ImgData
  }

  useEffect(() => {
    if (!paramId || !fileList) return

    if (fileList?.length > 0) {
      addAllImagesList(
        fileList.map(item => ({
          ...item,
          productId: productId,
          paramId: paramId,
        })),
      )
    } else {
      removeImagesInAllList(paramId)
    }
  }, [fileList])

  useEffect(() => {
    if (files) setFileList(files)

    return () => {
      addAllImagesList([])
    }
  }, [files])

  return (
    <div>
      <Controller
        control={control}
        name={`${productId}`}
        render={() => (
          <DragDropInput
            limit={5}
            errorText='1 файл не загружен - превышен лимит'
            loadFileToApi={loadFile}
            helperTitle='Загрузите файл'
            allowedFormats='image/png, image/jpeg, image/jpg'
            fileList={fileList}
            setFileList={setFileList}
            isError={false}
            labelName={name}
          />
        )}
      />
    </div>
  )
}
